if (!customElements.get("tyre-finder")) {
  customElements.define(
    "tyre-finder",
    class YearSearch extends HTMLElement {
      constructor() {
        super();
        this.getFilterURL = "";
        this.etrtoFilter = this.querySelector(".select__etrto_data");
        this.frenchFilter = this.querySelector(".select__french_data");
        this.inchFilter = this.querySelector(".select__inch_data");
        this.wheelFilter = this.querySelector(".select__wheel_data");
        this.searchURL = this.querySelector(".search__url");

        this.etrtoFilter?.addEventListener("change", () => {
          this.handleExclusiveSelect(this.etrtoFilter);
          this.updateSearchURL("etrto", this.etrtoFilter.value);
        });

        this.frenchFilter?.addEventListener("change", () => {
          this.handleExclusiveSelect(this.frenchFilter);
          this.updateSearchURL("french", this.frenchFilter.value);
        });

        this.inchFilter?.addEventListener("change", () => {
          this.handleExclusiveSelect(this.inchFilter);
          this.updateSearchURL("inch", this.inchFilter.value);
        });

        this.wheelFilter?.addEventListener("change", () => {
          this.handleExclusiveSelect(this.wheelFilter);
          this.updateSearchURL("wheel", this.wheelFilter.value);
        });

        this.initDropdown(this.etrtoFilter, "ETRTO Size", "etrto");
        this.initDropdown(this.frenchFilter, "French Size", "french");
        this.initDropdown(this.inchFilter, "Inch Size", "inch");
        this.initDropdown(this.wheelFilter, "Wheel Size", "wheel");
      }

      resetDropdown(dropdown, placeholder) {
        dropdown.innerHTML = `<option value="select">${placeholder}</option>`;
        dropdown.disabled = true;
      }

      disableSearchLink() {
        this.searchURL.removeAttribute("href");
        this.searchURL.setAttribute("disabled", "true");
        this.searchURL.classList.add("disabled");
      }

      enableSearchLink(url) {
        this.searchURL.setAttribute("href", url);
        this.searchURL.removeAttribute("disabled");
        this.searchURL.classList.remove("disabled");
      }

      handleExclusiveSelect(activeDropdown) {
        const dropdowns = [
          this.etrtoFilter,
          this.frenchFilter,
          this.inchFilter,
          this.wheelFilter,
        ];
        const selectedValue = activeDropdown.value;

        dropdowns.forEach((dropdown) => {
          if (dropdown !== activeDropdown) {
            dropdown.disabled = selectedValue !== "select";
          }
        });

        if (selectedValue === "select") {
          dropdowns.forEach((dropdown) => (dropdown.disabled = false));
          this.disableSearchLink();
        }
      }

      initDropdown(dropdown, label, filterKey) {
        fetch(`${tyreURL}?view=search.finder-tyre`)
          .then((response) => response.text())
          .then((response) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(response, "text/html");
            const selector = `.select__${filterKey}_data`;
            const options = doc.querySelectorAll(`${selector} option`);
            const values = Array.from(options).map((o) => o.value).filter((v) => v);
            const unique = [...new Set(values)];

            dropdown.innerHTML =
              `<option value="select">${label}</option>` +
              unique.map((v) => `<option value="${v}">${v}</option>`).join("");
          })
          .catch((err) => console.log(`Error initializing ${filterKey} filter:`, err));
      }

      updateSearchURL(type, value) {
        if (value === "select") {
          this.disableSearchLink();
          return;
        }

        let paramMap = {
          etrto: "tyre.etrto",
          french: "tyre.french",
          inch: "tyre.inch",
          wheel: "tyre.wheel",
        };

        const param = paramMap[type];
        const url = `${tyreURL}?filter.p.m.${param}=${value}`;
        this.enableSearchLink(url);
      }
    }
  );
}